// Static seed for the ecosystem (third-order domains of jakubjirak.com).
// This is the SEO-safe baseline: the landing grid renders from this even with
// no network / no Supabase. The CMS layer (site_links) augments it at runtime.
// Titles & descriptions are resolved from i18n (`ecosystem.items.<slug>.*`)
// unless the admin has overridden them in Supabase.

export interface EcosystemSeed {
  slug: string;
  url: string;
  /** short monogram shown in the card badge */
  monogram: string;
  /** accent colour (hex) for the badge */
  accent: string;
}

// Accents are 900-level shades: white badge text clears WCAG AAA (>=7:1) on all.
export const ecosystemSeed: EcosystemSeed[] = [
  { slug: 'ai',          url: 'https://ai.jakubjirak.com',          monogram: 'AI',  accent: '#1e3a8a' },
  { slug: 'a11y',        url: 'https://a11y.jakubjirak.com',        monogram: 'A11Y', accent: '#134e4a' },
  { slug: 'performance', url: 'https://performance.jakubjirak.com', monogram: 'PERF', accent: '#78350f' },
  { slug: 'costlens',    url: 'https://costlens.jakubjirak.com',    monogram: 'CL',  accent: '#4c1d95' },
  { slug: 'adr',         url: 'https://adr.jakubjirak.com',         monogram: 'ADR', accent: '#0c4a6e' },
  { slug: 'books',       url: 'https://books.jakubjirak.com',       monogram: 'BK',  accent: '#14532d' },
  // 'compound' lives in the CMS as hidden (is_published=false); un-hide it in
  // /admin (Links → Show) to surface it. Kept out of the seed so it stays hidden
  // in the SEO/offline fallback too.
];

// Hero CTA buttons (first module). slug maps to i18n key `hero.<slug>` so text
// stays localized; the CMS (category='hero_cta') overrides url/text/order/visibility.
export interface HeroCtaSeed {
  slug: string;
  url: string;
  variant: 'primary' | 'secondary';
}

export const heroCtaSeed: HeroCtaSeed[] = [
  { slug: 'cta_collaborate', url: '#contact',                    variant: 'primary' },
  { slug: 'cta_a11y',        url: 'https://a11y.jakubjirak.com', variant: 'secondary' },
  { slug: 'cta_ai',          url: 'https://ai.jakubjirak.com',   variant: 'secondary' },
];

// Social links (hero). CMS-managed via site_links category='social'; icon is a
// network name resolved by <SocialIcon>.
export interface SocialSeed {
  slug: string;
  url: string;
  icon: string;
  label: string;
}

export const socialSeed: SocialSeed[] = [
  { slug: 'linkedin', url: 'https://www.linkedin.com/in/jirakj/', icon: 'linkedin', label: 'LinkedIn' },
  { slug: 'github',   url: 'https://github.com/jirakj',           icon: 'github',   label: 'GitHub' },
  { slug: 'medium',   url: 'https://jakubjirak.medium.com',       icon: 'medium',   label: 'Medium' },
];

// Default hero trust-stat values (overridable via settings.hero_stats).
export const heroStatDefaults: Record<string, string> = {
  stat_years: '10+',
  stat_trained: '10k+',
  stat_tests: '1M+',
  stat_books: '12',
};
